import React, {Fragment} from 'react';

import {DebouncedInput} from 'app/general/primitives/DebouncedInput';
import {gt} from 'app/utils/i18n';

import {StepEditFieldProps} from '../commonprops';

export const StepEditTextField = ({
  label,
  onChange,
  optionsButton,
}: StepEditFieldProps) => (
  <Fragment>
    <div className="input-group">
      <DebouncedInput
        className="form-control"
        type="text"
        value={label}
        onChange={onChange}
        placeholder={gt('Field label...')}
      />
      {optionsButton}
    </div>
    <div className="input-group">
      <input
        className="form-control text-black-50"
        disabled
        type="text"
        value={gt('Field value is entered here')}
      />
    </div>
  </Fragment>
);
